/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordPresenceActivity } from './DiscordPresenceActivity';
import {
    DiscordPresenceActivityFromJSON,
    DiscordPresenceActivityFromJSONTyped,
    DiscordPresenceActivityToJSON,
    DiscordPresenceActivityToJSONTyped,
} from './DiscordPresenceActivity';

/**
 * 
 * @export
 * @interface DiscordPresenceBody
 */
export interface DiscordPresenceBody {
    /**
     * The observed member's Discord id.
     * @type {string}
     * @memberof DiscordPresenceBody
     */
    discordId: string;
    /**
     * Shared relay bot token (validated against DISCORD_BOT_RELAY_TOKEN by discordBotAuthentication).
     * @type {string}
     * @memberof DiscordPresenceBody
     */
    botToken: string;
    /**
     * The observed member's Discord display name (guild nickname / username) — legibility for unlinked members.
     * @type {string}
     * @memberof DiscordPresenceBody
     */
    displayName?: string;
    /**
     * 
     * @type {Array<DiscordPresenceActivity>}
     * @memberof DiscordPresenceBody
     */
    activities: Array<DiscordPresenceActivity>;
}

/**
 * Check if a given object implements the DiscordPresenceBody interface.
 */
export function instanceOfDiscordPresenceBody(value: object): value is DiscordPresenceBody {
    if (!('discordId' in value) || value['discordId'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    if (!('activities' in value) || value['activities'] === undefined) return false;
    return true;
}

export function DiscordPresenceBodyFromJSON(json: any): DiscordPresenceBody {
    return DiscordPresenceBodyFromJSONTyped(json, false);
}

export function DiscordPresenceBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordPresenceBody {
    if (json == null) {
        return json;
    }
    return {
        
        'discordId': json['discordId'],
        'botToken': json['botToken'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'activities': ((json['activities'] as Array<any>).map(DiscordPresenceActivityFromJSON)),
    };
}

export function DiscordPresenceBodyToJSON(json: any): DiscordPresenceBody {
    return DiscordPresenceBodyToJSONTyped(json, false);
}

export function DiscordPresenceBodyToJSONTyped(value?: DiscordPresenceBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discordId': value['discordId'],
        'botToken': value['botToken'],
        'displayName': value['displayName'],
        'activities': ((value['activities'] as Array<any>).map(DiscordPresenceActivityToJSON)),
    };
}

